/**
 * Centralized JsBarcode configuration for container labels.
 */
export const CONTAINER_BARCODE_CONFIG = Object.freeze({
    format: "CODE128",
    width: 2,
    height: 75,
    margin: 5,
    fontSize: 12
});



// WEBPACK FOOTER //
// ./src/components/wtn/containerBarcodeConfig.js